import { useEffect, useState } from 'react';

import Base from '../../../utils/base'
import CustomTable from '../../../layout/custom_table/index'

export default function Client() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('image'),
      data: 'file_name',
      type: 'image',
    },
    {
      label: base.i18n.t('name'),
      data: 'name',
    },
    {
      label: base.i18n.t('address'),
      data: 'address',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      if(data.file_name != null)
        data.file_name = base.host + '/image/client?file_name=' + data.file_name
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('client')}</h3>
      <CustomTable 
        url='/client' 
        arr_header={arr_header} 
        arr={arr} 
        url_update='/client/action'
        url_create='/client/action'
        url_delete='/client'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}